var React = require('react');

function FileSpreadsheet (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M272 128a16 16 0 0 1-16-16V0H24A23.94 23.94 0 0 0 0 23.88V488a23.94 23.94 0 0 0 23.88 24H360a23.94 23.94 0 0 0 24-23.88V128zm56 304a16 16 0 0 1-16 16H72a16 16 0 0 1-16-16V240a16 16 0 0 1 16-16h240a16 16 0 0 1 16 16z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M377 105L279.1 7a24 24 0 0 0-17-7H256v112a16 16 0 0 0 16 16h112v-6.1a23.9 23.9 0 0 0-7-16.9zm-65 119H72a16 16 0 0 0-16 16v192a16 16 0 0 0 16 16h240a16 16 0 0 0 16-16V240a16 16 0 0 0-16-16zM136 416H88v-48h48zm0-80H88v-48h48zm80 80h-48v-48h48zm0-80h-48v-48h48zm80 80h-48v-48h48zm0-80h-48v-48h48z","className":"fa-primary","key":2})]);
}

FileSpreadsheet.defaultProps = {"viewBox":"0 0 384 512","className":"icon"};

module.exports = FileSpreadsheet;

FileSpreadsheet.default = FileSpreadsheet;
